import { Typography } from "@mui/material";

export const PlaybookTitle = ({ text }: { text: string }) => {
  return (
    <Typography
      variant="h1"
      component="h2"
      sx={{ fontSize: "34px", color: "#005EAB", fontWeight: 700 }}
    >
      {text}
    </Typography>
  );
};
